import styled from '@emotion/styled';

export const StyledPageContainer = styled.div`
    &&& {
        div[data-testid='page-container'] {
            padding: 0;
            background-color: inherit;
        }
    }
`;

export const Header = styled.div`
    position: relative;
    margin-bottom: 50px;
    display: flex;
    justify-content: space-between;

    span {
        font-family: BCSansHeading, Arial, 'Helvetica Neue', Helvetica, sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 32px;
        line-height: 53px;
        color: #23085a;
    }

    &::after {
        content: '';
        width: 58px;
        height: 0;
        border: 3px solid #23085a;
        border-radius: 12px;
        left: 0;
        bottom: -20px;
        position: absolute;
    }
`;